import { createRef } from "react";
import ItineraryPage from "../pages/ItineraryPage";

// feature routes
export const routes = [
  // {
  //   path: "/itinerary",
  //   element: <ItineraryPage />,
  //   handle: {
  //     name: "Itinerary",
  //     nodeRef: createRef(),
  //   },
  // },
];
